<div [class]="'modal fade modal-'+ config.size + ' ' + config.customClass" [id]="modalId" tabindex="-1" [attr.aria-labelledby]="modalId + '-label'" aria-hidden="true" [attr.data-bs-backdrop]="config.backdrop" [attr.data-bs-keyboard]="config.keyboard">
  <div class="modal-dialog modal-dialog-centered" [ngClass]="{'modal-dialog-scrollable': config.scrollable}">
    <div class="modal-content">
      <div class="modal-header d-flex align-items-center justify-content-between pb-0 border-0">
          <h5 class="modal-title" [id]="modalId + '-label'">{{ config.title || '' }}</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close" (click)="close()">
            <i class="ti ti-x fs-20"></i>
          </a>
      </div>

      <div class="modal-body pt-2">
          <ng-template #dynamicContent></ng-template>
      </div>

      <div class="modal-footer d-flex justify-content-between pt-0 border-0">
        <ng-container *ngIf="config && config.buttons &&  config.buttons.length > 0">
            <button *ngFor="let button of config.buttons"
                    [ngClass]="button?.classes || 'btn btn-primary'"
                    (click)=" button.action()">
                {{ button?.label || 'Close' }}
            </button>
        </ng-container>
      </div>
  </div>
</div>
